import { ChatFileModel } from '@models/chat-file.model'

export class ChatReplyModel {
    static COLLECTION_NAME = 'clientCommunicationReply'

    _id?: any
    // createOId?: any
    communicationId?: string
    clientId?: string
    clinicName?: string
    clientName?: string
    createTime: number
    content: string
    isPatient: boolean
    clinicReact?: number
    patientReact?: number

    file?: ChatFileModel
}



// WEBPACK FOOTER //
// ./src/models/chat-reply.model.ts